<!-- eslint-disable -->
<template lang="pug">
    .box-body__counter(:class="{'game-preparation-multiplayer': playersNumber > 0}")
        .box-body__title(:class="{'box-body__title--small': isSmallTitle}") {{ $i18n.t('battle.battle_prepare') }}
        .box-body__finger(:class="{'multiplayer-two-three-players__finger': playersNumber < 4}")
            img(:src="currentFinger")
</template>

<script>
    /*eslint-disable*/
    import one from "../../assets/images/battles/counter/one.svg";
    import two from "../../assets/images/battles/counter/two.svg";
    import three from "../../assets/images/battles/counter/three.svg";

    export default {
        props: {
            counter: Number,
            playersNumber: {
                type: Number,
                default: 0,
            },
            isSmallTitle: {
                type: Boolean,
                default: false
            }
        },
        data () {
            return {
                one: one,
                two: two,
                three: three,
            }
        },
        computed: {
            currentFinger () {
                switch (this.counter) {
                    case 3: {
                        return this.three;
                    }
                    case 2: {
                        return this.two;
                    }
                    case 1: {
                        return this.one;
                    }
                }
            },
        }
    }
</script>

<style scoped lang="scss">
    .box-body__counter {
        @media screen and (max-width: 575px) {
            height: 100vh;
        }
    }
    .box-body__title {
        font-family: 'Appetite';
        font-style: normal;
        font-weight: 500;
        font-size: 42px;
        line-height: 42px;
        color: #2187FF;
        margin: 40px 0;
        @media screen and (max-width: 359px) {
            font-size: 32px;
            line-height: 32px;
            margin: 30px 0;
        }
    }
    .game-preparation-multiplayer {
        display: flex;
        flex-direction: column;
        align-items: center;
        transition: width .2s ease;
        .box-body__title {
            font-size: 36px;
            line-height: 36px;
            margin: 10px auto;
            @include media($xxl) {
                font-size: 42px;
                line-height: 42px;
            }
        }
        .box-body__title--small {
            font-size: 16px;
            line-height: 16px;
            @include media($xxl) {
                font-size: 24px;
                line-height: 24px;
            }
        }
        .box-body__finger {
            max-width: 30%;
            @include media($xl) {
                max-width: 35%;
            }
            @media screen and (min-width: 1600px) {
                max-width: 40%;
            }
        }
        .multiplayer-two-three-players__finger {
            max-width: 80%;
            margin-top: 20px;
        }
    }
</style>
